/**
 * Channel Request and Response Data Transfer Objects
 */
export interface ChannelReq {
  /**
   * ID
   */
  id: string
}

/**
 * Histories Request Data Transfer Object
 * @extends {ChannelReq}
 */
export interface ChannelHistoriesReq extends ChannelReq {
  /**
   * Limit the number of histories returned
   */
  limit?: number
  /**
   * Skip a number of histories
   */
  skip?: number
  /**
   * Get histories before a specific timestamp
   */
  before?: number
}

/**
 * Channel MP3 URL Request Data Transfer Object
 * @extends {ChannelReq}
 */
export interface ChannelMp3UrlReq extends ChannelReq {
  /**
   * Language of the channel
   */
  language: string,
  /**
   * Voice Gender
   */
  gender: string,
  /**
   * Message ID to generate the MP3 for
   */
  message_id: string
}

/**
 * Channel Summary Request Data Transfer Object
 * @extends {ChannelReq}
 */
export interface ChannelSummaryReq extends ChannelReq {
  /**
   * Language of the channel
   */
  language: string,
}

/**
 * Channel WebSocket Request Data Transfer Object
 * @extends {ChannelReq}
 */
export interface ChannelWSReq extends ChannelReq {
  /**
   * Viewer ID
   */
  viewer_id: string
}

/**
 * Channel Rating Request Data Transfer Object
 * @extends {ChannelReq}
 */
export interface ChannelRatingReq extends ChannelReq {
  /**
   * Channel ID
   */
  channel_id?: string,
  /**
   * Comment
   */
  comment?: string,
  /**
   * Session ID
   */
  session_id?: string,
  /**
   * Viewer ID
   */
  viewer_id: string
}
